import { Outlet, Link, useLocation } from "react-router-dom";
import { LayoutDashboard, Building2, Cpu, FileBarChart, Package, Users, LogOut, User, Store, Calculator, Boxes } from "lucide-react";
import { Button } from "@/components/ui/button";

const Layout = ({ user, onLogout, allowedPages = [] }) => {
  const location = useLocation();

  const allNavItems = [
    { path: "/", pageId: "dashboard", label: "Dashboard", icon: LayoutDashboard },
    { path: "/hospitals", pageId: "hospitals", label: "Hastaneler", icon: Building2 },
    { path: "/devices", pageId: "devices", label: "Cihazlar", icon: Cpu },
    { path: "/products", pageId: "products", label: "Ürün Envanteri", icon: Boxes },
    { path: "/dealers", pageId: "dealers", label: "Bayiler", icon: Store },
    { path: "/reports", pageId: "reports", label: "Prob Raporu", icon: FileBarChart },
    { path: "/biovics", pageId: "biovics", label: "Sternafix Raporu", icon: Package },
    { path: "/finans", pageId: "finans", label: "Finans", icon: Calculator, adminOnly: true },
    { path: "/users", pageId: "users", label: "Kullanıcılar", icon: Users, adminOnly: true },
  ];

  // Filter nav items based on user permissions
  const navItems = allNavItems.filter((item) => {
    if (user?.is_admin) return true;
    if (item.adminOnly) return false;
    return allowedPages.includes(item.pageId);
  });

  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar */}
      <aside className="w-64 border-r border-border bg-card flex flex-col">
        <div className="p-6 border-b border-border">
          <h1 className="text-2xl font-bold text-primary" data-testid="app-logo">
            Atlas Global CRM
          </h1>
          <p className="text-sm text-muted-foreground mt-1">Medikal Takip Programı</p>
        </div>
        <nav className="flex-1 p-4" data-testid="main-navigation">
          <ul className="space-y-2">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    data-testid={`nav-${item.pageId}`}
                    className={`flex items-center gap-3 px-4 py-3 rounded-md font-medium transition-colors ${
                      isActive
                        ? "bg-primary text-primary-foreground"
                        : "text-foreground hover:bg-accent hover:text-accent-foreground"
                    }`}
                  >
                    <Icon className="w-5 h-5" />
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
        
        {/* User Info & Logout */}
        <div className="p-4 border-t border-border space-y-3">
          {user && (
            <div className="flex items-center gap-3 p-3 bg-secondary rounded-lg" data-testid="user-info">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <User className="w-5 h-5 text-primary-foreground" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-sm truncate">{user.username}</p>
                <p className="text-xs text-muted-foreground">
                  {user.is_admin ? "Admin" : "Kullanıcı"}
                </p>
              </div>
            </div>
          )}
          <Button
            variant="outline"
            className="w-full justify-start gap-2"
            onClick={onLogout}
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4" />
            Çıkış Yap
          </Button>
          <p className="text-xs text-muted-foreground text-center">
            © 2026 Atlas Global
          </p>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <div className="p-6 md:p-8 lg:p-12">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
